import { render, staticRenderFns } from "./graduateTable.vue?vue&type=template&id=220f942a&scoped=true"
import script from "./graduateTable.vue?vue&type=script&lang=js"
export * from "./graduateTable.vue?vue&type=script&lang=js"
import style0 from "./graduateTable.vue?vue&type=style&index=0&id=220f942a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f942a",
  null
  
)

export default component.exports